import styled from "styled-components";
import { ApiTableColumn } from "../../../types/ApiTable/ApiTableColumn";
import { Button, Form, FormGroup } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { TableContext } from "../Context/TableContext";

interface TextSearchProps {
  column: ApiTableColumn;
}

const SearchButton = styled(Button)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

const SearchBox = styled(Form.Control)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const TextSearch = ({ column }: TextSearchProps) => {
  const [inputValue, setInputValue] = useState("");
  const {
    state: { filters },
    updateFilter,
    clearFilter,
  } = useContext(TableContext)!;
  const [currentFilterValue, setCurrentFilterValue] = useState(
    filters?.find((f) => f.field === column.field),
  );

  useEffect(() => {
    setInputValue(currentFilterValue?.value ?? "");
  }, [currentFilterValue?.value]);

  const getFilterServiceText = (column: ApiTableColumn, value: string) => {
    return `${column.filter?.filterKey ?? column.field} eq ${value}`;
  };

  const handleSearch = () => {
    if (!inputValue || inputValue.trimStart() === "") {
      clearFilter(column.field);
      setCurrentFilterValue(undefined);
    } else {
      const filter = {
        field: column.field,
        filterText: `${column.label} = ${inputValue}`,
        value: inputValue,
        filterServiceText: getFilterServiceText(column, inputValue),
      };
      updateFilter(filter);
      setCurrentFilterValue(filter);
    }
  };

  useEffect(() => {
    setCurrentFilterValue(filters?.find((f) => f.field === column.field));
  }, [filters, column]);

  return (
    <>
      <FormGroup className="w-100">
        {column.filter?.label && (
          <Form.Label className="mb-0">{column.filter.label} `</Form.Label>
        )}
        <div className="w-100 d-flex">
          <SearchBox
            type="text"
            value={inputValue}
            onChange={(e: any) => setInputValue(e.target.value)}
            placeholder={column.filter?.placeholder || "Search..."}
          />
          <SearchButton onClick={handleSearch}>
            <FontAwesomeIcon icon={faMagnifyingGlass} />
          </SearchButton>
        </div>
      </FormGroup>
    </>
  );
};

export default TextSearch;
